export const LifecycleHook = Object.freeze({
    Lock: 'lock',
    Unlock: 'unlock',
    Clear: 'clear',
    Import: 'import',
    Backup: 'backup',
    AddSeed: 'add-seed',
    RestoreSeed: 'restore-seed',
    Migrate: 'migrate',
    Start: 'start',
    Stop: 'stop',
    Restart: 'restart',
    Load: 'load',
    Unload: 'unload',
    Create: 'create',
    Restore: 'restore',
    RestoreCompleted: 'restore-completed',
    AssetsSynced: 'assets-synced',
    ChangePassphrase: 'change-passphrase',
});
